module.exports = __webpack_public_path__ + "static/media/shop-online-logo.81e667d7.svg";